import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { CONTACTS_ACTION_TYPE } from '../actions';

const initialState = {
  allContacts: [],
  applicationContacts: [],
  lookedUpValues: [],
};

const contactsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CONTACTS_ACTION_TYPE.ADD_CONTACTS:
        draft.allContacts = _.uniqBy(
          draft.allContacts.concat(payload.contacts),
          ({ emailAddress }) => _.toLower(emailAddress),
        );
        draft.lookedUpValues = _.union(draft.lookedUpValues, payload.lookedUpValues);
        break;

      case CONTACTS_ACTION_TYPE.GET_APPLICATION_CONTACTS:
        draft.applicationContacts = payload || initialState.applicationContacts;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default contactsReducer;
